import {makeAdUrl} from '@frontend/helpers'
import type {
    AdPreviewDataForGrid,
    AdPreviewDataForList,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {HorizontalSwiper} from '@shared/components/TouchHandler/HorizontalSwiper'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'

interface AdPhotosSwiperProps {
    ad: AdPreviewDataForGrid | AdPreviewDataForList
}

// Список фотографий объявления для предпросмотра в списке объявлений.
export function AdPreviewPhotosSwiper(props: AdPhotosSwiperProps) {

    const {
        ad,
    } = props

    // Индекс отображаемой фотографии.
    const [
        photoIndex,
        setPhotoIndex,
    ] = useState<number>(0)

    // Показать следующую картинку.
    const nextImage = useEventCallback(() => {
        setPhotoIndex((photoIndex + 1) % ad.photos.length)
    })

    // Показать предыдущую картинку.
    const prevImage = useEventCallback(() => {
        setPhotoIndex(
            photoIndex === 0
                ? ad.photos.length - 1
                : photoIndex - 1
        )
    })

    // Обработчик нажатия на ссылку объявления.
    const onClick = useEventCallback(() => {
        AnalyticsEventReporter.clickOnAdFromList(ad)
    })

    return (
        <HorizontalSwiper
            onNext={nextImage}
            onPrevious={prevImage}
            className="offered-item-card-images-swiper position-relative"
        >
            <Link
                to={makeAdUrl(ad.id)}
                style={
                    ad.photos.length
                        ? {backgroundImage: `url("${ad.photos[0]}")`}
                        : undefined
                }
                target="_blank"
                rel="noreferrer"
                className="offered-item-card-image rounded-6 shadow-3 position-relative"
                onClick={onClick}
            >
                {ad.photos.length > 1 && (
                    <>
                        {/* Отображение текущей выбранной картинки. */}
                        <span
                            className="offered-item-card-alternative-image rounded-6"
                            style={
                                ad.photos[photoIndex]
                                    ? {backgroundImage: `url("${ad.photos[photoIndex]}")`}
                                    : undefined
                            }
                        />
                        {/* Перелистывание картинок при движении курсора по блоку объявления. */}
                        <span className="offered-item-card-photo-changer flex-container-row">
                            {ad.photos.map((photo, index) => {
                                if (index > 5) {
                                    // Ограничиваем кол-во картинок для перелистывания.
                                    return null
                                }
                                return (
                                    <span
                                        key={photo}
                                        className="flex-1"
                                        onMouseEnter={() => setPhotoIndex(index)}
                                    />
                                )
                            })}
                        </span>
                    </>
                )}
            </Link>
            {ad.photos.length > 1 && (
                <div className="offered-item-card-images-nav">
                    {ad.photos.map((photo, index) => (
                        <div
                            key={photo}
                            className={index === photoIndex ? 'active' : ''}
                        />
                    ))}
                </div>
            )}
        </HorizontalSwiper>
    )
}
